sign_date
<template>
  <div class="user-list">
    <h3>{{ query.username }}的签到记录</h3>
    <div class="search-bar">
      <el-date-picker
        v-model="daas"
        type="daterange"
        value-format="yyyy-MM-dd HH:mm:ss"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="changeTime"
      >
      </el-date-picker>
    </div>
    <div class="table">
      <!-- <el-empty v-if="list.length==0" description="暂无记录"></el-empty> -->
      <div v-for="item in list" class="item">
        <div class="left">
          <h3>{{ item.course_title }}-{{ item.section_title }}</h3>
          <p>
            <label for="">签到时间：{{ item.sign_date }} </label
            ><span>{{ ["待签到", "正常签到", "迟到", "缺席"][item.sign_state] }}</span>
          </p>
        </div>
        <div class="right">
          <el-button @click="toMakeUp(item)">安排补课</el-button>
          <el-button @click="delItem(item)">删除</el-button>
        </div>
      </div>
      <!-- <div class="item">
                <div class="left">
                    <h3>护理员培训精品课程(基础</h3>
                    <p>签到时间：2020-1-12 12：22 <span>缺席</span></p>
                </div>
                <div class="right">
                    <el-button>安排补课</el-button>
                    <el-button>删除</el-button>
                </div>
            </div>
            <div class="item">
                <div class="left">
                    <h3>护理员培训精品课程(基础</h3>
                    <p>签到位置：是是是啥事所所所所</p>
                    <p>签到时间：2020-1-12 12：22  </p>
                </div>
                <div class="right">

                    <el-button>删除</el-button>
                </div>
            </div> -->
    </div>
    <el-dialog title="填写信息" :visible.sync="dialogVisible" center :before-close="handleClose">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
        <el-form-item label="补课地点" prop="address">
          <el-input v-model="ruleForm.address"></el-input>
          <!--      <el-select
                        v-model="ruleForm.times"

                        placeholder="请选择补课时间信息"

                        style="width: 100%;"
                    >
                        <el-option disabled="disabled" label="1" value="1">
                            <div class="option">
                                <span>时间</span>
                                <span>地点</span>

                            </div>
                        </el-option>
                        <el-option
                            v-for="(item,i) in class_info"
                            :key="i"
                            :label="'时间：'+item.lession_time+'  地点：'+item.lession_address"
                            :value="i"
                        >
                            <div class="option">
                                <span>{{ item.lession_time }}</span>
                                <span>{{ item.lession_address }}</span>

                            </div>
                        </el-option>

                    </el-select> -->
        </el-form-item>

        <el-form-item label="补课时间" prop="times">
          <el-date-picker
            v-model="ruleForm.times"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 100%"
            :picker-options="pickerOptions0"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="confirmMake">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { signDetail, delSign, makeUpsign, makeupTimeList } from "@/api/edu.js";
import { getTeacherList } from "@/api/teacher.js";
import { mixin } from "@/mixins/pagination.js";
export default {
  mixins: [mixin],
  data() {
    return {
      info: "",
      class_info: [],
      pickerOptions0: {
        disabledDate(time) {
          const three = new Date().getTime() + 180 * 24 * 3600 * 1000;
          return time.getTime() < Date.now() - 8.64e7;
          // return time.getTime() < Date.now() ;
        },
      },
      loading: false,
      teacherList: [],
      searchParam: {},
      ruleForm: {},
      rules: {
        address: [
          {
            required: true,
            message: "请输入补课地点",
            trigger: "blur",
          },
        ],
        times: [
          {
            required: true,
            message: "请选择时间",
            trigger: "change",
          },
        ],
      },
      query: {},
      daas: [],
      list: [],
      tableData: [],
      dialogVisible: false,
      actRow: {},
    };
  },
  mounted() {
    const query = this.$route.query;
    this.query = query;
    if (query.user_uuid) {
      this.getDetail();
    }
  },
  methods: {
    handleClose() {
      this.ruleForm = {};
      this.class_info = [];
      this.$refs["ruleForm"].resetFields();
      this.dialogVisible = false;
    },
    changeTime(val) {
      if (val) {
        this.searchParam = {
          ...this.searchParam,
          start_time: val[0],
          end_time: val[1],
        };
      } else {
        this.searchParam = {
          ...this.searchParam,
          start_time: "",
          end_time: "",
        };
      }
      this.getDetail();
    },
    confirmMake() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          makeUpsign({
            address: this.ruleForm.address, // item.lession_address,
            time_range: this.ruleForm.times.join(" - "), // item.lession_time,
            section_uuid: this.actRow.section_uuid,
            user_uuid: this.query.user_uuid,
          }).then((res) => {
            if (res == true) {
              this.getDetail();
              this.ruleForm = {};
              this.class_info = [];
              this.dialogVisible = false;
              this.$message.success("成功");
            }
          });
        }
      });
      // const item = this.class_info[this.ruleForm.times]
      // if (!item) {
      //     this.$message.warning('请选择补课信息')
      //     return
      // }
    },
    toMakeUp(item) {
      this.actRow = item;
      this.makeupTimeList(item);
    },
    makeupTimeList(item) {
      makeupTimeList(item.section_uuid).then((res) => {
        if (res && res.class_info instanceof Array) {
          this.class_info = res.class_info;
          this.dialogVisible = true;
        }
      });
    },
    delItem(item) {
      this.$confirm("确定要删除该记录吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delSign(item.id).then((res) => {
            if (res == true) {
              this.$message.success("成功");
              this.getDetail();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    getDetail() {
      signDetail({
        user_uuid: this.$route.query.user_uuid,
        ...this.searchParam,
      }).then((res) => {
        if (res.list instanceof Array) {
          this.list = res.list;
        }
      });
    },
    getTeacher(keyword_search) {
      getTeacherList({ keyword_search }).then((res) => {
        if (res.data instanceof Array) {
          this.teacherList = res.data;
        }
      });
    },
    toDetail(row) {
      console.log(row);
      this.$router.push({
        path: "/sign-record",
        query: row,
      });
    },

    setTop(row) {},
    xiajia(row) {},
    agree() {},
    noagree(row) {
      this.$confirm("确定要拒绝该申请吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {})
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async getList() {
      const param = {
        page_index: this.page_index,
        page_size: this.page_size,
        ...this.searchParam,
      };
      this.loading = true;
      const res = await getLiveList(param);
      this.loading = false;
      if (res.data instanceof Array) {
        this.tableData = res.data;
        this.total = res.total;
      }
    },
  },
};
</script>

<style scoped="scoped" lang="less">
.user-list {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}
.item {
  display: flex;
  justify-content: space-between;
  border: 1px solid #bbb;
  margin: 10px 0;
  padding: 10px;
  align-items: center;
  .left {
    width: 70%;
  }
  p {
    display: flex;
    align-items: center;
    margin-top: 20px;
  }
  label {
    min-width: 200px;
  }
  span {
    color: red;
  }
}
</style>
